import { motion } from "framer-motion";
import { FlaskConical } from "lucide-react";
import { CtaButton } from "./Cta";

export const Nav = () => (
  <motion.nav
    data-testid="main-nav"
    initial={{ y: -70, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#070B12]/70 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
      <a href="#" data-testid="nav-logo" className="flex items-center gap-2.5">
        <span className="flex h-8 w-8 items-center justify-center rounded-md border border-cyan-400/40 bg-cyan-400/10">
          <FlaskConical className="h-4 w-4 text-cyan-300" />
        </span>
        <span className="font-display text-sm font-bold tracking-[0.18em] text-slate-100">
          ABSORBANCIA <span className="text-cyan-400">PERFECTA</span>
        </span>
      </a>
      <div className="hidden items-center gap-2.5 font-tech text-[11px] tracking-[0.25em] text-emerald-300 md:flex">
        <span className="status-pulse h-2 w-2 rounded-full bg-emerald-400" />
        MATRÍCULAS ABIERTAS
      </div>
      <CtaButton size="sm" testId="nav-cta-button">
        Inscribirme
      </CtaButton>
    </div>
  </motion.nav>
);
